<template>
    <div class="container-fluid container-fill">
        <div class="row">
            <div class="paper">
                <h2>
                    <router-link to="/Admin"><font-awesome-icon :icon="['fa', 'arrow-left']" class="pointer olive-green-text" /></router-link>
                    Program Services
                    <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" style="margin-right:0.5rem;" />
                    <font-awesome-icon :icon="['fa', 'plus']" class="pointer olive-green-text" @click="CreateProgramServiceButton" />

                    <!-- Add / Edit ProgramService Modal -->
                    <span class="AddOrEditModal">
                        <b-modal ref="service-modal" :title="serviceModalTitle" hide-footer size="lg">
                            <b-container fluid>
                                <b-form @submit="SaveProgramService">
                                    <b-row>
                                        <b-col cols="12" md="6">
                                            <b-form-group label="Name:">
                                                <b-form-input v-model="serviceForm.Name" required></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6">
                                            <b-form-group label="Service Type:">
                                                <b-form-select v-model="serviceForm.ServiceType" :options="serviceTypeOptions"></b-form-select>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Description:">
                                                <b-form-textarea rows="3" v-model="serviceForm.Description"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" md="4">
                                            <b-form-group label="Census Weight:">
                                                <b-form-input v-model="serviceForm.CensusWeight" type="number" step="any"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="4">
                                            <b-form-group>
                                                <b-form-checkbox size="lg" v-model="serviceForm.CanHaveSupplementalAddition">Can Have Supplemental Addition</b-form-checkbox>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="4">
                                            <b-form-group>
                                                <b-form-checkbox size="lg" v-model="serviceForm.IsHasCustomRate">Has Custom Rate</b-form-checkbox>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="modal-btn-row">
                                        <div class="modal-btn-row-div">
                                            <b-button size="md" variant="secondary" @click="CancelServiceModal()">CANCEL</b-button>
                                            <b-button size="md" variant="primary" type="submit">SAVE</b-button>
                                        </div>
                                    </b-row>
                                </b-form>
                            </b-container>
                        </b-modal>
                    </span>

                    <!-- Membership (SubProgram) Add/Edit Modal -->
                    <span class="AddOrEditModal">
                        <b-modal ref="membership-modal" :title="membershipModalTitle" hide-footer size="lg">
                            <b-container fluid>
                                <b-form @submit="SaveMembership">
                                    <b-row>
                                        <b-col cols="12" md="6">
                                            <b-form-group label="Sub-Program:">
                                                <b-form-select v-model="membershipForm.SubProgramID" :options="subProgramOptions" required></b-form-select>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" md="4">
                                            <b-form-group label="Start Date:">
                                                <b-form-input v-model="membershipForm.StartDate" type="date" required></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="4">
                                            <b-form-group label="End Date:">
                                                <b-form-input v-model="membershipForm.EndDate" type="date"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" md="6">
                                            <b-form-group label="Revenue Account:">
                                                <b-form-input v-model="membershipForm.RevenueAccount"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6">
                                            <b-form-group label="Cost Account:">
                                                <b-form-input v-model="membershipForm.CostAccount"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="modal-btn-row">
                                        <div class="modal-btn-row-div">
                                            <b-button size="md" variant="secondary" @click="CancelMembershipModal()">CANCEL</b-button>
                                            <b-button size="md" variant="primary" type="submit">SAVE</b-button>
                                        </div>
                                    </b-row>
                                </b-form>
                            </b-container>
                        </b-modal>
                    </span>

                    <!-- Revenue Model Add / Edit Modal -->
                    <span class="AddOrEditModal">
                        <b-modal ref="revenue-model-modal" :title="revenueModelModalTitle" hide-footer size="xl">
                            <b-container fluid>
                                <b-form @submit="SaveRevenueModel">
                                    <b-row>
                                        <b-col cols="12" md="6">
                                            <b-form-group label="Name:">
                                                <b-form-input v-model="revenueModelForm.Name" required></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6">
                                            <b-form-group label="Unit Type:">
                                                <b-form-select v-model="revenueModelForm.UnitType" :options="unitTypeOptions" required></b-form-select>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" md="4">
                                            <b-form-group label="Revenue Per Unit:">
                                                <b-form-input v-model="revenueModelForm.RevenuePerUnit" type="number" step="0.01"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="4">
                                            <b-form-group label="Expense Per Unit:">
                                                <b-form-input v-model="revenueModelForm.ExpensePerUnit" type="number" step="0.01"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="4">
                                            <b-form-group label="Sort Order:">
                                                <b-form-input v-model="revenueModelForm.SortOrder" type="number" step="1"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" md="4">
                                            <b-form-group label="Start Date:">
                                                <b-form-input v-model="revenueModelForm.StartDate" type="date" required></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="4">
                                            <b-form-group label="End Date:">
                                                <b-form-input v-model="revenueModelForm.EndDate" type="date"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="4">
                                            <b-form-group label="Zone Applicability:">
                                                <b-form-input v-model="revenueModelForm.ZoneApplicability"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" md="6">
                                            <b-form-group label="Partial Unit Proration Method:">
                                                <b-form-select v-model="revenueModelForm.PartialUnitProrationMethod" :options="prorationMethodOptions"></b-form-select>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6">
                                            <b-form-group label="Partial Unit Static Rate:">
                                                <b-form-input v-model="revenueModelForm.PartialUnitStaticRate" type="number" step="0.01"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" md="6">
                                            <b-form-group label="Age Range Start:">
                                                <b-form-input v-model="revenueModelForm.AgeRangeApplicabilityStart" type="number" step="1"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6">
                                            <b-form-group label="Age Range End:">
                                                <b-form-input v-model="revenueModelForm.AgeRangeApplicabilityEnd" type="number" step="1"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" md="4">
                                            <b-form-group>
                                                <b-form-checkbox size="lg" v-model="revenueModelForm.IsCustomRevenuePerUnit">Custom Revenue Per Unit</b-form-checkbox>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="4">
                                            <b-form-group>
                                                <b-form-checkbox size="lg" v-model="revenueModelForm.IsCustomExpensePerUnit">Custom Expense Per Unit</b-form-checkbox>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="4">
                                            <b-form-group>
                                                <b-form-checkbox  size="lg" v-model="revenueModelForm.IsSupplementalAdditionPerUnit">Supplemental Addition Per Unit</b-form-checkbox>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="modal-btn-row">
                                        <div class="modal-btn-row-div">
                                            <b-button size="md" variant="secondary" @click="CancelRevenueModelModal()">CANCEL</b-button>
                                            <b-button size="md" variant="primary" type="submit">SAVE</b-button>
                                        </div>
                                    </b-row>
                                </b-form>
                            </b-container>
                        </b-modal>
                    </span>

                    <!-- Link Existing Revenue Model Modal -->
                    <span class="AddOrEditModal">
                        <b-modal ref="revenue-model-link-modal" title="Link Existing Revenue Model" hide-footer size="lg">
                            <b-container fluid>
                                <b-form @submit="SaveRevenueModelLink">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Revenue Model:">
                                                <b-form-select v-model="revenueModelLinkForm.ProgramServiceRevenueModelID"
                                                               :options="revenueModelOptions"
                                                               required></b-form-select>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="modal-btn-row">
                                        <div class="modal-btn-row-div">
                                            <b-button size="md" variant="secondary" @click="CancelRevenueModelLinkModal()">CANCEL</b-button>
                                            <b-button size="md" variant="primary" type="submit">LINK</b-button>
                                        </div>
                                    </b-row>
                                </b-form>
                            </b-container>
                        </b-modal>
                    </span>

                    <!-- Memberships Management Dialog -->
                    <span class="AddOrEditModal">
                        <b-modal ref="memberships-dialog"
                                 :title="'Sub-Program Memberships: ' + (selectedService ? selectedService.Name : '')"
                                 hide-footer size="xl" size="lg">
                            <b-container fluid>
                                <div style="margin-bottom:1rem; text-align:right;">
                                    <b-button variant="success" size="sm" @click="CreateMembershipButton">
                                        <font-awesome-icon :icon="['fa', 'plus']" /> Add Membership
                                    </b-button>
                                </div>
                                <vuetable :fields="MembershipTableOptions.Fields"
                                          :data-manager="MembershipDataManager"
                                          pagination-path=""
                                          :api-mode="false"
                                          ref="membershiptable">
                                    <template slot="StartDate" scope="props">
                                        {{ formatDateDisplay(props.rowData.StartDate) }}
                                    </template>
                                    <template slot="EndDate" scope="props">
                                        {{ formatDateDisplay(props.rowData.EndDate) }}
                                    </template>
                                    <template slot="MembershipActions" scope="props">
                                        <div>
                                            <b-row no-gutters>
                                                <b-col md="auto">
                                                    <font-awesome-icon :icon="['fa', 'edit']"
                                                                       style="font-size:24px; margin-right:1rem;"
                                                                       class="pointer orange"
                                                                       @click="EditMembershipButton(props.rowData)" />
                                                </b-col>
                                                <b-col md="auto">
                                                    <ActionButtonWithIcon :requires-confirmation="true"
                                                                          confirmation-string="WARNING: You are about to delete this membership. Are you sure?"
                                                                          endpoint="Admin/ProgramServiceManagement/DeleteSubProgramMembership"
                                                                          :payload="{ Id: props.rowData.Id }"
                                                                          :perform-global-update="false"
                                                                          button-variant="success"
                                                                          button-string=""
                                                                          button-size="md"
                                                                          v-on:success="RefreshMemberships"
                                                                          icon-prefix="fa"
                                                                          icon-suffix="trash-alt"
                                                                          icon-color="red"
                                                                          method="POST" />
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </template>
                                </vuetable>
                            </b-container>
                        </b-modal>
                    </span>

                    <!-- Revenue Models Management Dialog -->
                    <span class="AddOrEditModal">
                        <b-modal ref="revenue-models-dialog"
                                 :title="'Revenue Models: ' + (selectedService ? selectedService.Name : '')"
                                 hide-footer size="lg">
                            <b-container fluid>
                                <div style="margin-bottom:1rem; text-align:right;">
                                    <b-button variant="success" size="sm" class="mr-2" @click="CreateRevenueModelButton">
                                        <font-awesome-icon :icon="['fa', 'plus']" /> Add Revenue Model
                                    </b-button>
                                    <b-button variant="outline-primary"
                                              size="sm"
                                              @click="CreateRevenueModelLinkButton"
                                              :disabled="revenueModelOptions.length <= 1">
                                        <font-awesome-icon :icon="['fa', 'link']" /> Link Existing
                                    </b-button>
                                </div>
                                <b-alert show variant="light" style="margin-bottom:1rem;">
                                    New revenue models created here are automatically linked to this Program Service. Editing or deleting a revenue model updates every Program Service linked to it.
                                </b-alert>
                                <vuetable :fields="RevenueModelTableOptions.Fields"
                                          :data-manager="RevenueModelDataManager"
                                          pagination-path=""
                                          :api-mode="false"
                                          ref="revenueModelTable">
                                    <template slot="RevenuePerUnit" scope="props">
                                        {{ formatCurrencyDisplay(props.rowData.RevenuePerUnit) }}
                                    </template>
                                    <template slot="ExpensePerUnit" scope="props">
                                        {{ formatCurrencyDisplay(props.rowData.ExpensePerUnit) }}
                                    </template>
                                    <template slot="StartDate" scope="props">
                                        {{ formatDateDisplay(props.rowData.StartDate) }}
                                    </template>
                                    <template slot="EndDate" scope="props">
                                        {{ formatDateDisplay(props.rowData.EndDate) || 'Present' }}
                                    </template>
                                    <template slot="RevenueModelActions" scope="props">
                                        <div>
                                            <b-row no-gutters>
                                                <b-col md="auto">
                                                    <font-awesome-icon :icon="['fa', 'edit']"
                                                                       style="font-size:24px; margin-right:1rem;"
                                                                       class="pointer orange"
                                                                       @click="EditRevenueModelButton(props.rowData)" />
                                                </b-col>
                                                <b-col md="auto">
                                                    <ActionButtonWithIcon :requires-confirmation="true"
                                                                          confirmation-string="WARNING: You are about to unlink this revenue model from the current Program Service. Are you sure?"
                                                                          endpoint="Admin/ProgramServiceManagement/DeleteProgramServiceRevenueModelMembership"
                                                                          :payload="{ Id: props.rowData.MembershipID }"
                                                                          :perform-global-update="false"
                                                                          button-variant="success"
                                                                          button-string=""
                                                                          button-size="md"
                                                                          v-on:success="RefreshRevenueModels"
                                                                          icon-prefix="fa"
                                                                          icon-suffix="unlink"
                                                                          icon-color="orange"
                                                                          method="POST" />
                                                </b-col>
                                                <b-col md="auto">
                                                    <ActionButtonWithIcon :requires-confirmation="true"
                                                                          confirmation-string="WARNING: You are about to delete this revenue model from every Program Service it is linked to. Are you sure?"
                                                                          endpoint="Admin/ProgramServiceManagement/DeleteProgramServiceRevenueModel"
                                                                          :payload="{ Id: props.rowData.ProgramServiceRevenueModelID }"
                                                                          :perform-global-update="false"
                                                                          button-variant="success"
                                                                          button-string=""
                                                                          button-size="md"
                                                                          v-on:success="RefreshRevenueModels"
                                                                          icon-prefix="fa"
                                                                          icon-suffix="trash-alt"
                                                                          icon-color="red"
                                                                          method="POST" />
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </template>
                                </vuetable>
                            </b-container>
                        </b-modal>
                    </span>
                </h2>

                <!-- Search / Filter bar -->
                <b-row style="margin-bottom:0.5rem; margin-top:0.5rem;">
                    <b-col cols="12" md="4">
                        <b-form-input v-model="searchQuery"
                                      placeholder="Search by Name or Description..."
                                      @input="OnFilterChange">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" md="4">
                        <b-form-select v-model="filterCoreProgramID"
                                       :options="coreProgramOptions"
                                       @change="OnFilterChange">
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" md="4">
                        <b-form-select v-model="filterSubProgramID"
                                       :options="subProgramFilterOptions"
                                       @change="OnFilterChange">
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row style="margin-bottom:1rem;">
                    <b-col cols="12" md="auto">
                        <b-form-checkbox size="lg" v-model="groupByCoreProgram">Group By Core Program</b-form-checkbox>
                    </b-col>
                    <b-col cols="12" md="auto">
                        <b-form-checkbox size="lg" v-model="groupBySubProgram">Group By Sub Program</b-form-checkbox>
                    </b-col>
                    <b-col cols="12" md="auto" class="ml-auto">
                        <ReportDownloader report-label="Download Master Rates Sheet"
                                          endpoint="Core/Reports/ProgramReports/ProgramServiceRevenueReport"
                                          :parameter-schema="ProgramServiceRevenueReportParams"
                                          report-description="Generates an Excel file listing all Program Services (grouped by Core Program and Sub Program) with their revenue model details effective on the specified date." />
                    </b-col>
                </b-row>

                <!-- Program Services table (ungrouped) -->
                <div v-if="!isGrouped" class="vue-datatable">
                    <vuetable :fields="ServiceTableOptions.Fields"
                              :data-manager="DataManager"
                              pagination-path=""
                              :api-mode="false"
                              ref="servicetable">
                        <template slot="SubProgramCount" scope="props">
                            <span v-b-tooltip.html.hover :title="getSubProgramTooltip(props.rowData)">
                                {{ getSubProgramCount(props.rowData) }}
                            </span>
                        </template>
                        <template slot="ServiceActions" scope="props">
                            <div>
                                     <b-row no-gutters>
                                         <b-col md="auto">
                                             <font-awesome-icon :icon="['fa', 'edit']"
                                                           style="font-size:24px; margin-right:1rem;"
                                                            class="pointer orange"
                                                            @click="EditProgramServiceButton(props.rowData)" />
                                     </b-col>
                                     <b-col md="auto">
                                         <font-awesome-icon :icon="['fa', 'dollar-sign']"
                                                            style="font-size:24px; margin-right:1rem;"
                                                            class="pointer olive-green-text"
                                                            @click="ManageRevenueModelsButton(props.rowData)"
                                                            title="Manage Revenue Models" />
                                     </b-col>
                                     <b-col md="auto">
                                         <font-awesome-icon :icon="['fa', 'list']"
                                                           style="font-size:24px; margin-right:1rem;"
                                                           class="pointer olive-green-text"
                                                           @click="ManageMembershipsButton(props.rowData)"
                                                           title="Manage Sub-Program Memberships" />
                                    </b-col>
                                    <b-col md="auto">
                                        <ActionButtonWithIcon :requires-confirmation="true"
                                                              confirmation-string="WARNING: You are about to delete this Program Service. Are you sure?"
                                                              endpoint="Admin/ProgramServiceManagement/DeleteProgramService"
                                                              :payload="{ Id: props.rowData.Id }"
                                                              :perform-global-update="false"
                                                              button-variant="success"
                                                              button-string=""
                                                              button-size="md"
                                                              v-on:success="RefreshDataTable"
                                                              icon-prefix="fa"
                                                              icon-suffix="trash-alt"
                                                              icon-color="red"
                                                              method="POST" />
                                    </b-col>
                                </b-row>
                            </div>
                        </template>
                    </vuetable>
                </div>

                <!-- Program Services table (grouped) -->
                <div v-else class="vue-datatable">
                    <table class="table table-bordered table-hover table-sm">
                        <thead class="sticky-thead">
                            <tr>
                                <th>Name</th>
                                <th>Service Type</th>
                                <th>Description</th>
                                <th>Census Weight</th>
                                <th>Sub Programs</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(row, idx) in groupedRows">
                                <tr v-if="row._isGroupHeader"
                                    :key="'hdr-' + idx"
                                    :class="row._level === 1 ? 'table-primary' : 'table-secondary'">
                                    <td colspan="6" style="font-weight:bold; padding-left: 1rem;">
                                        <span v-if="row._level === 2" style="margin-left:1.5rem;"></span>
                                        {{ row._groupLabel }}
                                    </td>
                                </tr>
                                <tr v-else :key="'row-' + idx">
                                    <td>{{ row.Name }}</td>
                                    <td>{{ row.ServiceType }}</td>
                                    <td>{{ row.Description }}</td>
                                    <td>{{ row.CensusWeight }}</td>
                                    <td>
                                        <span v-b-tooltip.html.hover :title="getSubProgramTooltip(row)">
                                            {{ getSubProgramCount(row) }}
                                        </span>
                                    </td>
                                    <td>
                                         <b-row no-gutters>
                                             <b-col md="auto">
                                                 <font-awesome-icon :icon="['fa', 'edit']"
                                                                   style="font-size:24px; margin-right:1rem;"
                                                                    class="pointer orange"
                                                                    @click="EditProgramServiceButton(row)" />
                                             </b-col>
                                             <b-col md="auto">
                                                 <font-awesome-icon :icon="['fa', 'dollar-sign']"
                                                                    style="font-size:24px; margin-right:1rem;"
                                                                    class="pointer olive-green-text"
                                                                    @click="ManageRevenueModelsButton(row)"
                                                                    title="Manage Revenue Models" />
                                             </b-col>
                                             <b-col md="auto">
                                                 <font-awesome-icon :icon="['fa', 'list']"
                                                                   style="font-size:24px; margin-right:1rem;"
                                                                   class="pointer olive-green-text"
                                                                   @click="ManageMembershipsButton(row)"
                                                                   title="Manage Sub-Program Memberships" />
                                            </b-col>
                                            <b-col md="auto">
                                                <ActionButtonWithIcon :requires-confirmation="true"
                                                                      confirmation-string="WARNING: You are about to delete this Program Service. Are you sure?"
                                                                      endpoint="Admin/ProgramServiceManagement/DeleteProgramService"
                                                                      :payload="{ Id: row.Id }"
                                                                      :perform-global-update="false"
                                                                      button-variant="success"
                                                                      button-string=""
                                                                      button-size="md"
                                                                      v-on:success="RefreshDataTable"
                                                                      icon-prefix="fa"
                                                                      icon-suffix="trash-alt"
                                                                      icon-color="red"
                                                                      method="POST" />
                                            </b-col>
                                        </b-row>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import ActionButtonWithIcon from '../Admin/ActionButtonWithIcon.vue';
    import ReportDownloader from '../Core/UI/ReportDownloader.vue';
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowLeft);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faDollarSign } from '@fortawesome/free-solid-svg-icons';
    library.add(faDollarSign);
    import { faLink } from '@fortawesome/free-solid-svg-icons';
    library.add(faLink);
    import { faUnlink } from '@fortawesome/free-solid-svg-icons';
    library.add(faUnlink);

    export default {
        name: "ProgramServicePane",
        data() {
            return {
                ProgramServices: [],
                Memberships: [],
                RevenueModels: [],
                selectedService: null,
                searchQuery: '',
                filterCoreProgramID: '',
                filterSubProgramID: '',
                groupByCoreProgram: false,
                groupBySubProgram: false,
                coreProgramOptions: [],
                programServiceLinks: [],
                subProgramOptions: [],
                revenueModelOptions: [],
                ProgramServiceRevenueReportParams: [
                    {
                        Label: 'Target Date',
                        Name: 'TargetDate',
                        Type: 'Date',
                        Required: true
                    }
                ],
                serviceTypeOptions: [
                    { value: null, text: '-- Select Type --' },
                    { value: 'MentalHealth', text: 'Mental Health' },
                    { value: 'Census', text: 'Census' }
                ],
                serviceForm: {
                    Id: '',
                    Name: '',
                    ServiceType: null,
                    Description: '',
                    CensusWeight: null,
                    CanHaveSupplementalAddition: false,
                    IsHasCustomRate: false
                },
                membershipForm: {
                    Id: '',
                    ProgramServiceID: '',
                    SubProgramID: '',
                    StartDate: '',
                    EndDate: '',
                    RevenueAccount: '',
                    CostAccount: ''
                },
                revenueModelForm: {
                    Id: '',
                    Name: '',
                    UnitType: null,
                    RevenuePerUnit: '',
                    ExpensePerUnit: '',
                    PartialUnitProrationMethod: null,
                    PartialUnitStaticRate: '',
                    IsCustomRevenuePerUnit: false,
                    IsCustomExpensePerUnit: false,
                    IsSupplementalAdditionPerUnit: false,
                    AgeRangeApplicabilityStart: '',
                    AgeRangeApplicabilityEnd: '',
                    ZoneApplicability: '',
                    SortOrder: '',
                    StartDate: '',
                    EndDate: ''
                },
                revenueModelLinkForm: {
                    ProgramServiceRevenueModelID: ''
                },
                ServiceTableOptions: {
                    Fields: [
                        { name: 'Name', title: 'Name', sortField: 'Name' },
                        { name: 'ServiceType', title: 'Service Type', sortField: 'ServiceType' },
                        { name: 'Description', title: 'Description', sortField: 'Description' },
                        { name: 'CensusWeight', title: 'Census Weight', sortField: 'CensusWeight' },
                        { name: '__slot:SubProgramCount', title: 'Sub Programs' },
                        { name: '__slot:ServiceActions', title: 'Actions' }
                    ]
                },
                MembershipTableOptions: {
                    Fields: [
                        { name: 'SubProgram.Name', title: 'Sub-Program', sortField: 'SubProgram.Name' },
                        { name: '__slot:StartDate', title: 'Start Date' },
                        { name: '__slot:EndDate', title: 'End Date' },
                        { name: 'RevenueAccount', title: 'Revenue Account', sortField: 'RevenueAccount' },
                        { name: 'CostAccount', title: 'Cost Account', sortField: 'CostAccount' },
                        { name: '__slot:MembershipActions', title: 'Actions' }
                    ]
                },
                RevenueModelTableOptions: {
                    Fields: [
                        { name: 'Name', title: 'Name', sortField: 'Name' },
                        { name: 'UnitType', title: 'Unit Type', sortField: 'UnitType' },
                        { name: '__slot:RevenuePerUnit', title: 'Revenue / Unit' },
                        { name: '__slot:ExpensePerUnit', title: 'Expense / Unit' },
                        { name: '__slot:StartDate', title: 'Start Date' },
                        { name: '__slot:EndDate', title: 'End Date' },
                        { name: 'SortOrder', title: 'Sort Order', sortField: 'SortOrder' },
                        { name: '__slot:RevenueModelActions', title: 'Actions' }
                    ]
                },
                unitTypeOptions: [
                    { value: null, text: '-- Select Unit Type --' },
                    { value: 'ServiceNightMonth', text: 'Service Night Month' },
                    { value: 'ServiceNight', text: 'Service Night' },
                    { value: 'ServiceDayMonth', text: 'Service Day Month' },
                    { value: 'ServiceDay', text: 'Service Day' },
                    { value: 'RespiteNight', text: 'Respite Night' }
                ],
                prorationMethodOptions: [
                    { value: null, text: '-- None --' },
                    { value: 'MonthAnnualizedDividedByNights', text: 'Month Annualized / Nights' },
                    { value: 'StaticRate', text: 'Static Rate' }
                ]
            };
        },
        computed: {
            serviceModalTitle() {
                return this.serviceForm.Id ? 'Edit Program Service' : 'Add Program Service';
            },
            membershipModalTitle() {
                return this.membershipForm.Id ? 'Edit Sub-Program Membership' : 'Add Sub-Program Membership';
            },
            revenueModelModalTitle() {
                return this.revenueModelForm.Id ? 'Edit Revenue Model' : 'Add Revenue Model';
            },
            subProgramFilterOptions() {
                const dataOpts = this.subProgramOptions.filter(o => o.value !== '');
                return [{ value: '', text: '-- All Sub-Programs --' }, ...dataOpts];
            },
            isGrouped() {
                return this.groupByCoreProgram || this.groupBySubProgram;
            },
            filteredProgramServices() {
                let results = this.ProgramServices;
                const q = (this.searchQuery || '').toLowerCase().trim();
                if (q) {
                    results = results.filter(ps => {
                        const name = (ps.Name || '').toLowerCase();
                        const desc = (ps.Description || '').toLowerCase();
                        return name.includes(q) || desc.includes(q);
                    });
                }
                if (this.filterSubProgramID) {
                    const filterVal = this.filterSubProgramID.toLowerCase();
                    const matchIds = new Set(
                        this.programServiceLinks
                            .filter(l => (l.SubProgramID || '').toLowerCase() === filterVal)
                            .map(l => (l.ProgramServiceID || '').toLowerCase())
                    );
                    results = results.filter(ps => matchIds.has((ps.Id || '').toLowerCase()));
                }
                if (this.filterCoreProgramID) {
                    const filterVal = this.filterCoreProgramID.toLowerCase();
                    const matchIds = new Set(
                        this.programServiceLinks
                            .filter(l => (l.CoreProgramID || '').toLowerCase() === filterVal)
                            .map(l => (l.ProgramServiceID || '').toLowerCase())
                    );
                    results = results.filter(ps => matchIds.has((ps.Id || '').toLowerCase()));
                }
                return results;
            },
            groupedRows() {
                if (!this.isGrouped) return [];
                const services = this.filteredProgramServices;
                const links = this.programServiceLinks.filter(l => !l.EndDate);
                const rows = [];
                const psIdOf = s => (s.Id || '').toLowerCase();
                const linkPsId = l => (l.ProgramServiceID || '').toLowerCase();

                if (this.groupByCoreProgram && this.groupBySubProgram) {
                    // Two-level: CoreProgram → SubProgram → Services
                    const coreMap = new Map();
                    services.forEach(svc => {
                        links.filter(l => linkPsId(l) === psIdOf(svc)).forEach(l => {
                            const cpName = l.CoreProgramName || '(No Core Program)';
                            const spName = l.SubProgramName || '(No Sub-Program)';
                            if (!coreMap.has(cpName)) coreMap.set(cpName, new Map());
                            const subMap = coreMap.get(cpName);
                            if (!subMap.has(spName)) subMap.set(spName, []);
                            if (!subMap.get(spName).find(s => s.Id === svc.Id)) {
                                subMap.get(spName).push(svc);
                            }
                        });
                    });
                    [...coreMap.keys()].sort().forEach(cpName => {
                        rows.push({ _isGroupHeader: true, _groupLabel: cpName, _level: 1 });
                        const subMap = coreMap.get(cpName);
                        [...subMap.keys()].sort().forEach(spName => {
                            rows.push({ _isGroupHeader: true, _groupLabel: spName, _level: 2 });
                            subMap.get(spName).forEach(svc => rows.push(svc));
                        });
                    });
                } else if (this.groupByCoreProgram) {
                    const coreMap = new Map();
                    services.forEach(svc => {
                        links.filter(l => linkPsId(l) === psIdOf(svc)).forEach(l => {
                            const cpName = l.CoreProgramName || '(No Core Program)';
                            if (!coreMap.has(cpName)) coreMap.set(cpName, []);
                            if (!coreMap.get(cpName).find(s => s.Id === svc.Id)) {
                                coreMap.get(cpName).push(svc);
                            }
                        });
                    });
                    [...coreMap.keys()].sort().forEach(cpName => {
                        rows.push({ _isGroupHeader: true, _groupLabel: cpName, _level: 1 });
                        coreMap.get(cpName).forEach(svc => rows.push(svc));
                    });
                } else if (this.groupBySubProgram) {
                    const subMap = new Map();
                    services.forEach(svc => {
                        links.filter(l => linkPsId(l) === psIdOf(svc)).forEach(l => {
                            const spName = l.SubProgramName || '(No Sub-Program)';
                            if (!subMap.has(spName)) subMap.set(spName, []);
                            if (!subMap.get(spName).find(s => s.Id === svc.Id)) {
                                subMap.get(spName).push(svc);
                            }
                        });
                    });
                    [...subMap.keys()].sort().forEach(spName => {
                        rows.push({ _isGroupHeader: true, _groupLabel: spName, _level: 1 });
                        subMap.get(spName).forEach(svc => rows.push(svc));
                    });
                }
                return rows;
            }
        },
        methods: {
            // ── Program Service Methods ──────────────────────────────────────
            CreateProgramServiceButton() {
                this.serviceForm = { Id: '', Name: '', ServiceType: null, Description: '', CensusWeight: null, CanHaveSupplementalAddition: false, IsHasCustomRate: false };
                this.$refs['service-modal'].show();
            },
            EditProgramServiceButton(rowData) {
                this.serviceForm = {
                    Id: rowData.Id,
                    Name: rowData.Name,
                    ServiceType: rowData.ServiceType,
                    Description: rowData.Description,
                    CensusWeight: rowData.CensusWeight,
                    CanHaveSupplementalAddition: rowData.CanHaveSupplementalAddition,
                    IsHasCustomRate: rowData.IsHasCustomRate
                };
                this.$refs['service-modal'].show();
            },
            CancelServiceModal() {
                this.$refs['service-modal'].hide();
            },
            SaveProgramService(e) {
                e.preventDefault();
                const endpoint = this.serviceForm.Id
                    ? 'Admin/ProgramServiceManagement/UpdateProgramService'
                    : 'Admin/ProgramServiceManagement/CreateProgramService';
                this.$MasterAPI.ExecuteRequest('POST', endpoint, this.serviceForm, this.SaveProgramServiceSuccess, () => { }, true);
            },
            SaveProgramServiceSuccess() {
                this.$refs['service-modal'].hide();
                this.RefreshDataTable();
            },
            ManageMembershipsButton(rowData) {
                this.selectedService = rowData;
                this.$MasterAPI.ExecuteRequest('GET', 'Admin/ProgramServiceManagement/GetSubProgramMemberships', { Id: rowData.Id }, (response) => {
                    this.Memberships = response.data.data;
                    this.$refs['memberships-dialog'].show();
                    this.$nextTick(() => {
                        if (this.$refs.membershiptable) {
                            this.$refs.membershiptable.refresh();
                        }
                    });
                }, () => { }, true);
            },
            ManageRevenueModelsButton(rowData) {
                this.selectedService = rowData;
                this.RefreshRevenueModels(() => {
                    this.$refs['revenue-models-dialog'].show();
                });
            },
            OnFilterChange() {
                if (!this.isGrouped && this.$refs.servicetable) {
                    this.$refs.servicetable.refresh();
                }
            },
            RefreshDataTable() {
                this.$MasterAPI.ExecuteRequest('GET', 'Admin/ProgramServiceManagement/GetProgramServices', {}, (response) => {
                    this.ProgramServices = response.data.data;
                    if (this.$refs.servicetable) {
                        this.$refs.servicetable.refresh();
                    }
                }, () => { }, true);
                this.LoadProgramServiceLinks();
            },
            DataManager(sortOrder) {
                let dataset = this.filteredList(this.filteredProgramServices, 'servicetable');
                return this.sortDataset(dataset, sortOrder);
            },

            // ── Membership Methods ───────────────────────────────────────────
            CreateMembershipButton() {
                this.membershipForm = {
                    Id: '',
                    ProgramServiceID: this.selectedService.Id,
                    SubProgramID: '',
                    StartDate: '',
                    EndDate: '',
                    RevenueAccount: '',
                    CostAccount: ''
                };
                this.$refs['membership-modal'].show();
            },
            EditMembershipButton(rowData) {
                this.membershipForm = {
                    Id: rowData.Id,
                    ProgramServiceID: rowData.ProgramServiceID,
                    SubProgramID: (rowData.SubProgramID || '').toLowerCase(),
                    StartDate: rowData.StartDate ? rowData.StartDate.substring(0, 10) : '',
                    EndDate: rowData.EndDate ? rowData.EndDate.substring(0, 10) : '',
                    RevenueAccount: rowData.RevenueAccount,
                    CostAccount: rowData.CostAccount
                };
                this.$refs['membership-modal'].show();
            },
            CancelMembershipModal() {
                this.$refs['membership-modal'].hide();
            },
            SaveMembership(e) {
                e.preventDefault();
                const endpoint = this.membershipForm.Id
                    ? 'Admin/ProgramServiceManagement/UpdateSubProgramMembership'
                    : 'Admin/ProgramServiceManagement/CreateSubProgramMembership';
                this.$MasterAPI.ExecuteRequest('POST', endpoint, this.membershipForm, this.SaveMembershipSuccess, () => { }, true);
            },
            SaveMembershipSuccess() {
                this.$refs['membership-modal'].hide();
                this.RefreshMemberships();
            },
            RefreshMemberships() {
                if (!this.selectedService) return;
                this.$MasterAPI.ExecuteRequest('GET', 'Admin/ProgramServiceManagement/GetSubProgramMemberships', { Id: this.selectedService.Id }, (response) => {
                    this.Memberships = response.data.data;
                    this.$nextTick(() => {
                        if (this.$refs.membershiptable) {
                            this.$refs.membershiptable.refresh();
                        }
                    });
                }, () => { }, true);
                this.LoadProgramServiceLinks();
            },
            MembershipDataManager(sortOrder) {
                let dataset = this.filteredList(this.Memberships, 'membershiptable');
                return this.sortDataset(dataset, sortOrder);
            },

            // ── Revenue Model Methods ─────────────────────────────────────────
            CreateRevenueModelButton() {
                this.revenueModelForm = {
                    Id: '',
                    Name: '',
                    UnitType: null,
                    RevenuePerUnit: '',
                    ExpensePerUnit: '',
                    PartialUnitProrationMethod: null,
                    PartialUnitStaticRate: '',
                    IsCustomRevenuePerUnit: false,
                    IsCustomExpensePerUnit: false,
                    IsSupplementalAdditionPerUnit: false,
                    AgeRangeApplicabilityStart: '',
                    AgeRangeApplicabilityEnd: '',
                    ZoneApplicability: '',
                    SortOrder: '',
                    StartDate: this.currentDateString(),
                    EndDate: ''
                };
                this.$refs['revenue-model-modal'].show();
            },
            EditRevenueModelButton(rowData) {
                this.revenueModelForm = {
                    Id: rowData.ProgramServiceRevenueModelID,
                    Name: rowData.Name,
                    UnitType: rowData.UnitType,
                    RevenuePerUnit: rowData.RevenuePerUnit,
                    ExpensePerUnit: rowData.ExpensePerUnit,
                    PartialUnitProrationMethod: rowData.PartialUnitProrationMethod,
                    PartialUnitStaticRate: rowData.PartialUnitStaticRate,
                    IsCustomRevenuePerUnit: rowData.IsCustomRevenuePerUnit,
                    IsCustomExpensePerUnit: rowData.IsCustomExpensePerUnit,
                    IsSupplementalAdditionPerUnit: rowData.IsSupplementalAdditionPerUnit,
                    AgeRangeApplicabilityStart: rowData.AgeRangeApplicabilityStart,
                    AgeRangeApplicabilityEnd: rowData.AgeRangeApplicabilityEnd,
                    ZoneApplicability: rowData.ZoneApplicability,
                    SortOrder: rowData.SortOrder,
                    StartDate: rowData.StartDate ? rowData.StartDate.substring(0, 10) : '',
                    EndDate: rowData.EndDate ? rowData.EndDate.substring(0, 10) : ''
                };
                this.$refs['revenue-model-modal'].show();
            },
            CancelRevenueModelModal() {
                this.$refs['revenue-model-modal'].hide();
            },
            SaveRevenueModel(e) {
                e.preventDefault();
                const payload = this.BuildRevenueModelPayload();
                const endpoint = this.revenueModelForm.Id
                    ? 'Admin/ProgramServiceManagement/UpdateProgramServiceRevenueModel'
                    : 'Admin/ProgramServiceManagement/CreateProgramServiceRevenueModel';
                this.$MasterAPI.ExecuteRequest('POST', endpoint, payload, this.SaveRevenueModelSuccess, () => { }, true);
            },
            SaveRevenueModelSuccess() {
                this.$refs['revenue-model-modal'].hide();
                this.RefreshRevenueModels();
            },
            CreateRevenueModelLinkButton() {
                this.revenueModelLinkForm = { ProgramServiceRevenueModelID: '' };
                this.LoadRevenueModelOptions(() => {
                    this.$refs['revenue-model-link-modal'].show();
                });
            },
            CancelRevenueModelLinkModal() {
                this.$refs['revenue-model-link-modal'].hide();
            },
            SaveRevenueModelLink(e) {
                e.preventDefault();
                if (!this.selectedService) return;
                const payload = {
                    ProgramServiceID: this.selectedService.Id,
                    ProgramServiceRevenueModelID: this.revenueModelLinkForm.ProgramServiceRevenueModelID
                };
                this.$MasterAPI.ExecuteRequest('POST', 'Admin/ProgramServiceManagement/CreateProgramServiceRevenueModelMembership', payload, this.SaveRevenueModelLinkSuccess, () => { }, true);
            },
            SaveRevenueModelLinkSuccess() {
                this.$refs['revenue-model-link-modal'].hide();
                this.RefreshRevenueModels();
            },
            RefreshRevenueModels(afterLoad) {
                if (!this.selectedService) return;
                this.$MasterAPI.ExecuteRequest('GET', 'Admin/ProgramServiceManagement/GetProgramServiceRevenueModels', { Id: this.selectedService.Id }, (response) => {
                    this.RevenueModels = response.data.data;
                    this.LoadRevenueModelOptions(() => {
                        this.$nextTick(() => {
                            if (this.$refs.revenueModelTable) {
                                this.$refs.revenueModelTable.refresh();
                            }
                            if (afterLoad) {
                                afterLoad();
                            }
                        });
                    });
                }, () => { }, true);
            },
            RevenueModelDataManager(sortOrder) {
                let dataset = this.filteredList(this.RevenueModels, 'revenueModelTable');
                return this.sortDataset(dataset, sortOrder);
            },

            // ── Helpers ──────────────────────────────────────────────────────
            getSubProgramCount(ps) {
                const sId = (ps.Id || '').toLowerCase();
                return this.programServiceLinks.filter(l =>
                    (l.ProgramServiceID || '').toLowerCase() === sId && !l.EndDate
                ).length;
            },
            getSubProgramTooltip(ps) {
                const sId = (ps.Id || '').toLowerCase();
                const names = this.programServiceLinks
                    .filter(l => (l.ProgramServiceID || '').toLowerCase() === sId && !l.EndDate)
                    .map(l => l.SubProgramName || '');
                return names.join('<br>');
            },
            sortDataset(dataset, sortOrder) {
                if (!dataset || dataset.length === 0) return [];
                if (sortOrder && sortOrder.length > 0) {
                    const dir = sortOrder[0].direction === 'asc' ? 1 : -1;
                    return dataset.sort((a, b) => {
                        const va = this.$FindProperty(a, sortOrder[0].sortField);
                        const vb = this.$FindProperty(b, sortOrder[0].sortField);
                        return va > vb ? dir : -dir;
                    });
                }
                return dataset;
            },
            filteredList(inputData, refName) {
                let vm = this;
                if (!inputData) return [];
                let tRef = vm.$refs[refName];
                if (!tRef) return inputData;
                let tFields = tRef.tableFields;
                let visibleData = [];
                inputData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(tRef.renderNormalField(field, row));
                    });
                    visibleData.push(inputData[index]);
                });
                return visibleData;
            },
            formatDateDisplay(dateStr) {
                if (!dateStr) return '';
                const datePart = dateStr.substring(0, 10); // "yyyy-MM-dd"
                const parts = datePart.split('-');
                if (parts.length !== 3) return dateStr;
                return `${parts[1]}/${parts[2]}/${parts[0]}`;
            },
            formatCurrencyDisplay(value) {
                if (value === null || value === undefined || value === '') return '';
                return `$${Number(value).toFixed(2)}`;
            },
            currentDateString() {
                return new Date().toISOString().substring(0, 10);
            },
            ToNullableNumber(value) {
                return value === '' || value === null || value === undefined ? null : Number(value);
            },
            BuildRevenueModelPayload() {
                const payload = {
                    Id: this.revenueModelForm.Id || undefined,
                    Name: this.revenueModelForm.Name,
                    UnitType: this.revenueModelForm.UnitType,
                    RevenuePerUnit: this.ToNullableNumber(this.revenueModelForm.RevenuePerUnit),
                    ExpensePerUnit: this.ToNullableNumber(this.revenueModelForm.ExpensePerUnit),
                    PartialUnitProrationMethod: this.revenueModelForm.PartialUnitProrationMethod || null,
                    PartialUnitStaticRate: this.ToNullableNumber(this.revenueModelForm.PartialUnitStaticRate),
                    IsCustomRevenuePerUnit: !!this.revenueModelForm.IsCustomRevenuePerUnit,
                    IsCustomExpensePerUnit: !!this.revenueModelForm.IsCustomExpensePerUnit,
                    IsSupplementalAdditionPerUnit: !!this.revenueModelForm.IsSupplementalAdditionPerUnit,
                    AgeRangeApplicabilityStart: this.ToNullableNumber(this.revenueModelForm.AgeRangeApplicabilityStart),
                    AgeRangeApplicabilityEnd: this.ToNullableNumber(this.revenueModelForm.AgeRangeApplicabilityEnd),
                    ZoneApplicability: this.revenueModelForm.ZoneApplicability || null,
                    SortOrder: this.ToNullableNumber(this.revenueModelForm.SortOrder),
                    StartDate: this.revenueModelForm.StartDate,
                    EndDate: this.revenueModelForm.EndDate || null
                };

                if (!this.revenueModelForm.Id && this.selectedService) {
                    payload.ProgramServiceID = this.selectedService.Id;
                }

                return payload;
            },
            LoadCoreProgramOptions() {
                this.$MasterAPI.ExecuteRequest('GET', 'Admin/ProgramServiceManagement/GetCoreProgramOptions', {}, (response) => {
                    const opts = response.data.data.map(o => ({ value: o.value, text: o.text }));
                    this.coreProgramOptions = [{ value: '', text: '-- All Core Programs --' }, ...opts];
                }, () => { }, true);
            },
            LoadProgramServiceLinks() {
                this.$MasterAPI.ExecuteRequest('GET', 'Admin/ProgramServiceManagement/GetProgramServiceMembershipLinks', {}, (response) => {
                    this.programServiceLinks = response.data.data;
                }, () => { }, true);
            },
            LoadSubProgramOptions() {
                this.$MasterAPI.ExecuteRequest('GET', 'Admin/ProgramServiceManagement/GetSubProgramOptions', {}, (response) => {
                    const opts = response.data.data.map(o => ({ value: (o.value || '').toLowerCase(), text: o.text }));
                    this.subProgramOptions = [{ value: '', text: '-- Select Sub-Program --' }, ...opts];
                }, () => { }, true);
            },
            LoadRevenueModelOptions(afterLoad) {
                if (!this.selectedService) {
                    this.revenueModelOptions = [{ value: '', text: '-- Select Revenue Model --' }];
                    if (afterLoad) afterLoad();
                    return;
                }
                this.$MasterAPI.ExecuteRequest('GET', 'Admin/ProgramServiceManagement/GetProgramServiceRevenueModelOptions', { Id: this.selectedService.Id }, (response) => {
                    const opts = response.data.data.map(o => ({ value: o.value, text: o.text }));
                    this.revenueModelOptions = [{ value: '', text: '-- Select Revenue Model --' }, ...opts];
                    if (afterLoad) {
                        afterLoad();
                    }
                }, () => { }, true);
            }
        },
        components: {
            ActionButtonWithIcon,
            Vuetable,
            ReportDownloader
        },
        mounted() {
            this.RefreshDataTable();
            this.LoadSubProgramOptions();
            this.LoadCoreProgramOptions();
        }
    }
</script>

<style scoped>
.sticky-thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #fff;
}

.vue-datatable >>> thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #fff;
}
</style>
